import request from '@/utils/request'

export function getUserApiSecret(params) {
  return request({
    url: process.env.WEB_API + '/openapi/getUserApiSecret',
    method: 'get',
    params
  });
}

export function refreshUserApiSecret(params) {
  return request({
    url: process.env.WEB_API + '/openapi/refreshUserApiSecret',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/openapi.js